import {
  RESERVE_GET_SERVICE_NUMBERS_REQUEST,
  RESERVE_GET_SERVICE_NUMBERS_SUCCESS,
  RESERVE_GET_SERVICE_NUMBERS_ERROR,
  ADD_RESERVE_SERVICE_NUMBERS_REQUEST,
  ADD_RESERVE_SERVICE_NUMBERS_SUCCESS,
  ADD_RESERVE_SERVICE_NUMBERS_ERROR,
  GET_UN_RESERVED_SERVICE_NUMBERS_REQUEST,
  GET_UN_RESERVED_SERVICE_NUMBERS_SUCCESS,
  GET_UN_RESERVED_SERVICE_NUMBERS_ERROR,
  REMOVE_RESERVE_SERVICE_NUMBERS_ERROR,
  REMOVE_RESERVE_SERVICE_NUMBERS_SUCCESS,
  REMOVE_RESERVE_SERVICE_NUMBERS_REQUEST,
  GET_CLEAR_SERVICE_NUMBER,
  GET_NEW_LINE_RESERVED_NUMBERS_ERROR,
  GET_NEW_LINE_RESERVED_NUMBERS_SUCCESS,
  GET_NEW_LINE_RESERVED_NUMBERS_REQUEST,
  IS_RESERVE_NUMBERS_SELECTED
} from '@/actions/reservenumber/actionTypes';
export const initialState = {
  isLoading: false,
  unReservedNumber: [],
  reservedNumber: [],
  error: '',
  isReserveSelected: false
};

const reserveNumberReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESERVE_GET_SERVICE_NUMBERS_REQUEST:
    case REMOVE_RESERVE_SERVICE_NUMBERS_REQUEST:
    case ADD_RESERVE_SERVICE_NUMBERS_REQUEST:
    case GET_NEW_LINE_RESERVED_NUMBERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: ''
      };
    case RESERVE_GET_SERVICE_NUMBERS_SUCCESS:
    case GET_NEW_LINE_RESERVED_NUMBERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: '',
        reservedNumber: action.data
      };
    case RESERVE_GET_SERVICE_NUMBERS_ERROR:
    case ADD_RESERVE_SERVICE_NUMBERS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error?.response?.data?.message
      };

    case GET_NEW_LINE_RESERVED_NUMBERS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error.response?.data?.message
      };

    case ADD_RESERVE_SERVICE_NUMBERS_SUCCESS:
    case REMOVE_RESERVE_SERVICE_NUMBERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: ''
      };

    case GET_UN_RESERVED_SERVICE_NUMBERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_UN_RESERVED_SERVICE_NUMBERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        unReservedNumber: action.data.t1
      };
    case GET_UN_RESERVED_SERVICE_NUMBERS_ERROR:
      return {
        ...state,
        isLoading: false
      };

    case REMOVE_RESERVE_SERVICE_NUMBERS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    case GET_CLEAR_SERVICE_NUMBER:
      return {
        ...state,
        isLoading: false,
        reservedNumber: action.data
      };

    case IS_RESERVE_NUMBERS_SELECTED:
      return {
        ...state,
        isReserveSelected: action.data
      };
    default:
      return state;
  }
};

export default reserveNumberReducer;
